// extracted by mini-css-extract-plugin
module.exports = {"signaturePad":"SignaturePad_signaturePad_2iEQ8","signaturePad_canvas":"SignaturePad_signaturePad_canvas_3VYQk","signaturePad_close":"SignaturePad_signaturePad_close_3Gj53"};